var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    color: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.834 2.38c0-.394-.373-.713-.834-.713s-.833.32-.833.714v8.107L6.423 7.744a.833.833 0 0 0-1.179 1.178l4.167 4.167a.833.833 0 0 0 1.179 0l4.166-4.167a.833.833 0 1 0-1.178-1.178l-2.744 2.744zM2.5 11.667c.46 0 .834.374.834.834v3.333a.833.833 0 0 0 .833.833h11.667a.833.833 0 0 0 .833-.833V12.5a.833.833 0 0 1 1.667 0v3.333a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5V12.5c0-.46.373-.834.833-.834"
  })));
};
export default SvgDownloadIcon;